import { Injectable, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface Configuration {
  production: boolean;
  apiUrl: string;
  jwtIssuerURL: string;
  viewFileUpLoadDir: string;
  appKey: string;
  env: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly CONFIG_URL = 'assets/appConfig.json';
  private configuration$!: Observable<Configuration>;

  production: boolean = false;
  appName: string = '';
  apiUrl: string = '';
  jwtIssuerURL: string = '';
  appKey: string = '';
  env: string = '';

  constructor(private location: Location, private http: HttpClient) {}

  async loadAppConfig() {
    let data: any = await this.http.get(this.CONFIG_URL).toPromise();

    this.production = data.production;
    this.apiUrl = data.apiUrl;
    this.jwtIssuerURL = data.jwtIssuerURL;
    this.appName = data.appName;
    this.env = data.env;
    this.appKey = data.appKey;
  }
}
